import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { delay, map, switchMap, tap } from 'rxjs/operators';

import { ErrorType, UserApiService, catchAppError } from '@core/api';

import { initActions } from '../actions/init.actions';
import { userActions, userApiActions } from '../actions/user.actions';

@Injectable()
export class UserEffects {
  private actions$ = inject(Actions);
  private router = inject(Router);
  private userApi = inject(UserApiService);

  logoutUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userApiActions.logoutSuccess),
      delay(1),
      map(() => initActions.appCleanup())
    )
  );

  tokenExpired$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userApiActions.tokenExpired),
      delay(1),
      tap(() => this.router.navigate(['/login'])),
      map(() => userApiActions.logoutSuccess())
    )
  );

  tokenDeleted$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userApiActions.tokenDeleted),
      delay(1),
      tap(() =>
        this.router.navigate(['/logged-out'], {
          state: { reason: 'token-deleted' },
        })
      ),
      map(() => userApiActions.logoutSuccess())
    )
  );

  fetchUserLayersGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userActions.fetchUserLayersGroups),
      switchMap(() =>
        this.userApi.fetchUserLayersGroups().pipe(
          map((userLayersGroups) => userApiActions.fetchUserLayersGroupsSuccess({ userLayersGroups })),
          catchAppError((error) => userApiActions.fetchUserLayersGroupsFail({ error }), ErrorType.CUSTOM)
        )
      )
    )
  );
}
